if (!customElements.get('cart-recommendations')) {
  class CartRecommendations extends HTMLElement {
    connectedCallback() {
      this.loadRecommendations();
    }

    async loadRecommendations() {
      if (this.dataset.loading === 'true') return;

      this.dataset.loading = 'true';

      let loaded = await this.fetchRecommendations(this.dataset.url);

      if (!loaded && this.dataset.fallbackUrl) {
        loaded = await this.fetchRecommendations(
          this.dataset.fallbackUrl
        );
      }

      if (!loaded) {
        this.remove();
      }
    }

    async fetchRecommendations(url) {
      if (!url) return false;

      try {
        const response = await fetch(url);

        if (!response.ok) return false;

        const responseText = await response.text();
        const responseDocument = new DOMParser().parseFromString(
          responseText,
          'text/html'
        );

        const content = responseDocument.querySelector(
          '[data-cart-recommendations-content]'
        );

        if (!content) return false;

        const cartProductIds = (
          this.dataset.cartProductIds || ''
        )
          .split(',')
          .map((id) => id.trim())
          .filter(Boolean);

        const recommendationItems = [
          ...content.querySelectorAll(
            '[data-cart-recommendation-item]'
          ),
        ];

        recommendationItems.forEach((item) => {
          if (cartProductIds.includes(item.dataset.productId)) {
            item.remove();
          }
        });

        const remainingItems = [
          ...content.querySelectorAll(
            '[data-cart-recommendation-item]'
          ),
        ];

        remainingItems.slice(2).forEach((item) => item.remove());

        if (remainingItems.length === 0) return false;

        this.replaceChildren(content);

        this.querySelectorAll(
          '[data-cart-recommendation-add]'
        ).forEach((button) => {
          button.addEventListener('click', (event) => {
            this.addToCart(event);
          });
        });

        return true;
      } catch (error) {
        console.error('Cart recommendations:', error);
        return false;
      }
    }

    async addToCart(event) {
      const button = event.currentTarget;
      const variantId = button.dataset.variantId;

      if (!variantId || button.disabled) return;

      const originalText = button.textContent.trim();

      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      button.textContent = 'Se adaugă…';

      const cartAddUrl =
        window.routes && window.routes.cart_add_url
          ? window.routes.cart_add_url
          : '/cart/add.js';

      try {
        const response = await fetch(cartAddUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify({
            id: Number(variantId),
            quantity: 1,
            sections: ['cart-drawer', 'cart-icon-bubble'],
            sections_url: window.location.pathname,
          }),
        });

        const cartState = await response.json();

        if (!response.ok || cartState.status) {
          throw new Error(
            cartState.description ||
              'Produsul nu a putut fi adăugat.'
          );
        }

        const cartDrawer = document.querySelector('cart-drawer');

        if (
          cartDrawer &&
          typeof cartDrawer.renderContents === 'function'
        ) {
          cartDrawer.renderContents(cartState);
        } else {
          window.location.reload();
        }
      } catch (error) {
        console.error('Cart recommendation add:', error);

        button.disabled = false;
        button.removeAttribute('aria-busy');
        button.textContent = 'Încearcă din nou';

        setTimeout(() => {
          button.textContent = originalText;
        }, 2500);
      }
    }
  }

  customElements.define(
    'cart-recommendations',
    CartRecommendations
  );
}